import _ from "../Trans";
import React, {useEffect, useState} from "react";
import ReactGA from "react-ga4";
import Config from "../Config";
import token from "../AuthToken";
import {toast} from "react-toastify";
import {Col, Container, Row} from "reactstrap";
import Currency from "./Currency";

const logoAsobal = process.env.REACT_APP_STATIC_URL + '/logo_asobal.png';
const logoEuro2024 = process.env.REACT_APP_STATIC_URL + '/logo_euro2024.png';
const logoHispanos = process.env.REACT_APP_STATIC_URL + '/logo-granollers-cup-2024.png';
const logoOlympicsMale = process.env.REACT_APP_STATIC_URL + '/logo_mens_olympic_2024.png';
const logoOlympicsFemale = process.env.REACT_APP_STATIC_URL + '/logo_womens_olympic_2024.png';
const logoAsobal2425 = process.env.REACT_APP_STATIC_URL + '/logo_asobal2425.png';

const activeTournamentText = _('Active game')

export default function Tournaments ({setTournament}) {
    const switchTournamentErrorMessage = _("Unable to switch tournament")
    const tournamentSwitchedMessage = _('Tournament switched')
    const unableToRetrievePreferencesMessage = _("Unable to retrieve preferences")
    const [activeTournament, setActiveTournament] = useState(null);
    const [pastTournaments, setPastTournaments] = useState([]);
    const [userId, setUserId] = useState(3);
    const [pastTournamentsComponent, setPastTournamentsComponent] = useState('');

    useEffect(() => {
        const tournamentsTitle = _('Tournaments');
        ReactGA.initialize(Config.GA_CODE);
        ReactGA.send({hitType: "pageview", page: "/tournaments/", title: tournamentsTitle});
    }, []);

    const getUserPreferences = function(e) {
        fetch(Config.fetchUserUrl, {
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json'
            }
        })
        .then((e) => {
            if (e.status < 300) {
                return e.json();
            }
            return Promise.reject(e)
        })
        .then(data => {
            setUserId(data.user_id)
            setActiveTournament(data.active_tournament_id)
            setPastTournaments(data.past_tournaments)
            return true;
        })
        .catch((e) => {
            if(e.status === 401) {
                window.location.href = Config.logoutPage;
            }
            toast.error(unableToRetrievePreferencesMessage, Config.toastConfig)
        })
    }

    useEffect(() => {
        getUserPreferences()
    }, []);  // eslint-disable-line

    const switchTournament = function(e) {
        let activeTournament = parseInt(e.currentTarget.dataset.tournamentId);
        fetch(Config.switchTournamentUrl.replace("/0/", "/"+userId+"/"), {
            headers: {
                Authorization: 'Token ' + token,
                'Content-Type': 'application/json'
            },
            method: "PUT",
            body: JSON.stringify({
                'active_tournament_id': activeTournament,
            })
        })
        .then((e) => {
            if (e.status < 300) {
                toast.success(tournamentSwitchedMessage, Config.toastConfig);
                setActiveTournament(activeTournament);
                setTournament(activeTournament);
                return true;
            }
            return Promise.reject(e)
        })
        .catch((e) => {
            if(e.status === 401) {
                window.location.href = Config.logoutPage;
            }
            toast.error(switchTournamentErrorMessage, Config.toastConfig)
        })
    }

    useEffect(function() {
        setPastTournamentsComponent(pastTournaments.map(
            (e) => (
                <PastTournament key={e.tournament_id} e={e}/>
            )
        ))
    }, [pastTournaments]);

    return (
        <Container id="tournaments">
            <Row className="text-left">
                <Col className="col-lg-2 d-none d-lg-block mt-4"/>
                <Col lg={8} md={8} sm={12} xs={12} className="mt-4">
                    <h2>{activeTournamentText}</h2>
                </Col>
            </Row>
            <Row className="text-left">
                <Col className="col-lg-2 d-none d-lg-block"/>
                <Col  lg={8} md={12} sm={12} xs={12} className="mt-3">
                    <div className="game game-asobal d-none">
                        <input onChange={switchTournament} data-tournament-id={1} type="radio" id="active_tournament_asobal" name="active_tournament" checked={activeTournament === 1}/>
                        <img src={logoAsobal} alt="Asobal"/>
                    </div>
                    <div className="game game-euro-2024 d-none">
                        <input onChange={switchTournament} data-tournament-id={2} type="radio" id="active_tournament_euro_2024" name="active_tournament" checked={activeTournament === 2}/>
                        <img src={logoEuro2024} alt="Euro 2024"/>
                    </div>
                    <div className="game game-granollers-hispanos d-none">
                        <input onChange={switchTournament} data-tournament-id={3} type="radio" id="active_tournament_granollers_hispanos" name="active_tournament" checked={activeTournament === 3}/>
                        <img src={logoHispanos} alt="Balonmano TIE Granollers #Hispanos"/>
                    </div>
                    <div className="game game-asobal2425">
                        <input onChange={switchTournament} data-tournament-id={20} type="radio" id="active_tournament_asobal2425" name="active_tournament" checked={activeTournament === 20}/>
                        <img src={logoAsobal2425} alt="Asobal 24/25"/>
                    </div>
                    <div className="game game-olympics-male d-none">
                        <input onChange={switchTournament} data-tournament-id={18} type="radio" id="active_tournament_olympics_male" name="active_tournament" checked={activeTournament === 18}/>
                        <img src={logoOlympicsMale} alt="Olympic 2024 male"/>
                    </div>
                    <div className="game game-olympics-female d-none">
                        <input onChange={switchTournament} data-tournament-id={19} type="radio" id="active_tournament_olympics_female" name="active_tournament" checked={activeTournament === 19}/>
                        <img src={logoOlympicsFemale} alt="Olympic 2024 female"/>
                    </div>
                </Col>
            </Row>
            <Row className="text-left mt-5">
                <Col className="col-lg-2 d-none d-lg-block"/>
                <Col  lg={8} md={8} sm={12} xs={12}>
                    <h2>{_('Past tournaments')}</h2>
                </Col>
            </Row>
            {pastTournamentsComponent}
            <Col className="mb-5" style={{display: 'block'}}><Row>&nbsp;</Row></Col>
        </Container>
    )
}

const PastTournament = function({e}) {
    const elementStyle = {color: 'white', fontWeight: 'bold'}
    const extraClasses = {
        1: 'game-asobal',
        2: 'game-euro-2024',
        3: 'game-granollers-hispanos',
        18: 'game-olympics-men',
        19: 'game-olympics-women',
        20: 'game-asobal2425'
    }
    let extraClass = {}
    extraClass = [extraClasses[e.tournament_id]];

    return (
        <Row className="text-left">
            <Col lg={2}></Col>
            <Col  lg={8} md={12} sm={12} xs={12} className="mt-3">
                <div className={extraClass + [" game game-history"]}>
                    <div>
                        {e.tournament_id === 1 &&
                            <img src={logoAsobal} className="game-asobal game" alt="Asobal"/>
                        }
                        {e.tournament_id === 2 &&
                            <img src={logoEuro2024} className="game-euro-2024 game" alt="Euro 2024"/>
                        }
                        {e.tournament_id === 3 &&
                            <img src={logoHispanos} className="game-granollers-hispanos game" alt="Balonmano TIE Granollers #Hispanos"/>
                        }
                        {e.tournament_id === 18 &&
                            <img src={logoOlympicsMale} className="game-olympics-male game" alt="Olympics 2024 Male"/>
                        }
                        {e.tournament_id === 19 &&
                            <img src={logoOlympicsFemale} className="game-olympics-female game" alt="Olympics 2024 Female"/>
                        }
                    </div>
                    <div className="ml-3 h4 mt-2" style={elementStyle}>
                        {e.name}<br/>
                    </div>
                    <div className=" d-flex justify-content-start">
                        <div className="ml-3 h4 mt-2 text-center" style={elementStyle}>
                            {e.global_position}º/{e.total_teams}<br/>
                            {e.total_points} {_('points')}
                        </div>
                        <div className="ml-5 h4 mt-2 text-right" style={elementStyle}>
                            <u>{_('Budget')}</u><br/>
                            <Currency value={e.current_value}/>
                        </div>
                        <div className="ml-5 h4 mt-2 text-right" style={elementStyle}>
                            <u>{_('Goals + Stops')}</u><br/>
                            {e.goals_and_stops}
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    )
}
